import { cheat, clear } from 'automaton/actions/RequestSpinAction'
import { signal } from 'services/SignalsService'
import { cheatValues } from 'settings/cheat'
import { log } from 'utils/Logger'

export class CheatGUI {
  constructor() {
    this.controllers = null
    this.folders = null
    this.cheat = {
      'Free Spins': () => {},
      'x2': () => {},
      'Big Win': () => {},
      'Mega Win': () => {},
      'Ultra Win': () => {},
      'fsRespin': () => {},
      'infinityRespin': () => {},
      'Matrix': '',
      'Set Matrix': () => {},
      'Clear': () => {},
    }

    this.createSignal()
  }

  createSignal() {
    signal.on('STATE:IN:INIT', this.init.bind(this))
  }

  init(){
    this.folders =  game.gui.folders
    this.controllers =  game.gui.controllers

    this.controllers.cheat = {}

    this.folders.cheat = game.gui.addFolder('Cheat')

    this.controllers.cheat.fs = this.folders.cheat.add(this.cheat, 'Free Spins')
    this.controllers.cheat.x2 = this.folders.cheat.add(this.cheat, 'x2')
    this.controllers.cheat.big = this.folders.cheat.add(this.cheat, 'Big Win')
    this.controllers.cheat.ultra = this.folders.cheat.add(this.cheat,  'Ultra Win')
    this.controllers.cheat.mega = this.folders.cheat.add(this.cheat, 'Mega Win')
    this.controllers.cheat.fsRespin = this.folders.cheat.add(this.cheat, 'fsRespin')
    this.controllers.cheat.infinity = this.folders.cheat.add(this.cheat, 'infinityRespin')
    this.controllers.cheat.matrix = this.folders.cheat.add(this.cheat, 'Matrix')
    this.controllers.cheat.setMatrix = this.folders.cheat.add(this.cheat, 'Set Matrix')
    this.controllers.cheat.clear = this.folders.cheat.add(this.cheat, 'Clear')

    this.controllers.cheat.setMatrix.onChange(this.set.bind(this))
    this.controllers.cheat.clear.onChange(this.delete.bind(this))
    this.controllers.cheat.fs.onChange(() => this.set.call(this, 'Free Spins'))
    this.controllers.cheat.x2.onChange(() => this.set.call(this, 'X2'))
    this.controllers.cheat.big.onChange(() => this.set.call(this, 'Big'))
    this.controllers.cheat.ultra.onChange(() => this.set.call(this, 'Ultra'))
    this.controllers.cheat.mega.onChange(() => this.set.call(this, 'Mega'))
    this.controllers.cheat.fsRespin.onChange(() => this.set.call(this, 'fsRespin'))
    this.controllers.cheat.infinity.onChange(() => this.set.call(this, 'infinityRespin'))
  }

  delete(){
    clear()
    this.controllers.cheat.matrix.setValue('')
  }

  set(val){
    cheat(val ? this.setMath.call(this, val) : this.cheat.Matrix)
  }

  setMath(val){
    const math = game.models.SpinModel.get().mathType

    if(cheatValues[math]) {
      return cheatValues[math][val]
    }
    else {
      // If occured go to settings/cheat.js and add new math values
      log('WARNING! UNKNOWN MATH TYPE IN CHEAT PANEL', 'WARNING')
      return ''
    }
  }
}
